import React from 'react';
import './ResearchHub.css';

const ResearchHub = () => {
  return <div className="research-empty container" />;
};

export default ResearchHub;
